/**
 * String template for the RNA CSV file defining the experiment design.
 */
export const RnaPairedSampleTemplate = `SampleName,Filename,Disease
Treated1,Treated1_S4_L001_R1_001.fastq.gz,treated
Treated1,Treated1_S4_L001_R2_001.fastq.gz,treated
Treated2,Treated2_S5_L001_R1_001.fastq.gz,treated
Treated2,Treated2_S5_L001_R2_001.fastq.gz,treated
Treated3,Treated3_S6_L001_R1_001.fastq.gz,treated
Treated3,Treated3_S6_L001_R2_001.fastq.gz,treated
Control1,Control1_S1_L001_R1_001.fastq.gz,control
Control1,Control1_S1_L001_R2_001.fastq.gz,control
Control2,Control2_S2_L001_R1_001.fastq.gz,control
Control2,Control2_S2_L001_R2_001.fastq.gz,control
Control3,Control3_S3_L001_R1_001.fastq.gz,control
Control3,Control3_S3_L001_R2_001.fastq.gz,control`;

export const RnaSingleSampleTemplate = `SampleName,Filename,Disease,Sex
Control1,Control1_S1_L001_R1_001.fastq.gz,control,Male
Control1,Control1_S1_L002_R1_001.fastq.gz,control,Male
Control1,Control1_S1_L003_R1_001.fastq.gz,control,Male
Control2,Control2_S2_L001_R1_001.fastq.gz,control,Male
Control2,Control2_S2_L002_R1_001.fastq.gz,control,Male
Control2,Control2_S2_L003_R1_001.fastq.gz,control,Male
Control3,Control3_S3_L001_R1_001.fastq.gz,control,Male
Control3,Control3_S3_L002_R1_001.fastq.gz,control,Male
Control3,Control3_S3_L003_R1_001.fastq.gz,control,Male
Control4,Control4_S4_L001_R1_001.fastq.gz,dilated_cardiomyopathy,Male
Control4,Control4_S4_L002_R1_001.fastq.gz,dilated_cardiomyopathy,Male
Control4,Control4_S4_L003_R1_001.fastq.gz,dilated_cardiomyopathy,Male
Control5,Control5_S5_L001_R1_001.fastq.gz,dilated_cardiomyopathy,Male
Control5,Control5_S5_L002_R1_001.fastq.gz,dilated_cardiomyopathy,Male
Control5,Control5_S5_L003_R1_001.fastq.gz,dilated_cardiomyopathy,Male
Control6,Control6_S6_L001_R1_001.fastq.gz,dilated_cardiomyopathy,Male
Control6,Control6_S6_L002_R1_001.fastq.gz,dilated_cardiomyopathy,Male
Control6,Control6_S6_L003_R1_001.fastq.gz,dilated_cardiomyopathy,Male
Disease1,Disease1_S7_L001_R1_001.fastq.gz,control,Female
Disease1,Disease1_S7_L002_R1_001.fastq.gz,control,Female
Disease1,Disease1_S7_L003_R1_001.fastq.gz,control,Female
Disease2,Disease2_S8_L001_R1_001.fastq.gz,control,Female
Disease2,Disease2_S8_L002_R1_001.fastq.gz,control,Female
Disease2,Disease2_S8_L003_R1_001.fastq.gz,control,Female
Disease3,Disease3_S9_L001_R1_001.fastq.gz,control,Female
Disease3,Disease3_S9_L002_R1_001.fastq.gz,control,Female
Disease3,Disease3_S9_L003_R1_001.fastq.gz,control,Female
Disease4,Disease4_S10_L001_R1_001.fastq.gz,dilated_cardiomyopathy,Female
Disease4,Disease4_S10_L002_R1_001.fastq.gz,dilated_cardiomyopathy,Female
Disease4,Disease4_S10_L003_R1_001.fastq.gz,dilated_cardiomyopathy,Female
Disease5,Disease5_S11_L001_R1_001.fastq.gz,dilated_cardiomyopathy,Female
Disease5,Disease5_S11_L002_R1_001.fastq.gz,dilated_cardiomyopathy,Female
Disease5,Disease5_S11_L003_R1_001.fastq.gz,dilated_cardiomyopathy,Female
Disease6,Disease6_S12_L001_R1_001.fastq.gz,dilated_cardiomyopathy,Female
Disease6,Disease6_S12_L002_R1_001.fastq.gz,dilated_cardiomyopathy,Female
Disease6,Disease6_S12_L003_R1_001.fastq.gz,dilated_cardiomyopathy,Female`;

/**
 * String template for the ChIP CSV file defining the experiment design.
 */
export const ChipPairedSampleTemplate = `SampleName,Replicate,Factor,Tissue,Condition,Treatment,SampleType,ControlName
Input_WT_rep1,1,Factor1,Tissue1,WT,,Input,Input
Input_WT_rep2,2,Factor1,Tissue1,WT,,Input,Input
IP_WT_rep1,1,Factor1,Tissue1,WT,,IP,Input_WT_rep1
IP_WT_rep2,2,Factor1,Tissue1,WT,,IP,Input_WT_rep2
Input_KO_rep1,1,Factor1,Tissue1,KO,,Input,Input
Input_KO_rep2,2,Factor1,Tissue1,KO,,Input,Input
IP_KO_rep1,1,Factor1,Tissue1,KO,,IP,Input_KO_rep1
IP_KO_rep2,2,Factor1,Tissue1,KO,,IP,Input_KO_rep2`;

export const ChipSingleSampleTemplate = `SampleName,Replicate,Factor,Tissue,Condition,Treatment,SampleType,ControlName
Factor1_IP_Tissue1_Treated_1,1,Factor1,Tissue1,Condition1,Treated,IP,Input_Tissue1_1
Factor1_IP_Tissue1_Control_1,1,Factor1,Tissue1,Condition1,Control,IP,Input_Tissue1_1
Factor2_IP_Tissue1_Treated_1,1,Factor2,Tissue1,Condition1,Treated,IP,Input_Tissue1_1
Factor2_IP_Tissue1_Control_1,1,Factor2,Tissue1,Condition1,Control,IP,Input_Tissue1_1
Input_Tissue1_1,1,Input,Tissue1,Input,Input,Input,Input`;

/**
 * String template for the ChIP CSV file listing the filenames.
 */
export const ChipPairedSampleFilenamesTemplate = `SampleName,Filename_1_1,Filename_1_2
Input_WT_rep1,Input_WT_rep1_S1_L001_R1_001.fastq.gz,Input_WT_rep1_S1_L001_R2_001.fastq.gz
Input_WT_rep2,Input_WT_rep2_S2_L001_R1_001.fastq.gz,Input_WT_rep2_S2_L001_R2_001.fastq.gz
IP_WT_rep1,IP_WT_rep1_S3_L001_R1_001.fastq.gz,IP_WT_rep1_S3_L001_R2_001.fastq.gz
IP_WT_rep2,IP_WT_rep2_S4_L001_R1_001.fastq.gz,IP_WT_rep2_S4_L001_R2_001.fastq.gz
Input_KO_rep1,Input_KO_rep1_S5_L001_R1_001.fastq.gz,Input_KO_rep1_S5_L001_R2_001.fastq.gz
Input_KO_rep2,Input_KO_rep2_S6_L001_R1_001.fastq.gz,Input_KO_rep2_S6_L001_R2_001.fastq.gz
IP_KO_rep1,IP_KO_rep1_S7_L001_R1_001.fastq.gz,IP_KO_rep1_S7_L001_R2_001.fastq.gz
IP_KO_rep2,IP_KO_rep2_S8_L001_R1_001.fastq.gz,IP_KO_rep2_S8_L001_R2_001.fastq.gz`;

export const ChipSingleSampleFilenamesTemplate = `SampleName,Filename
Factor1_IP_Tissue1_Treated_1,Factor1_IP_Tissue1_Treated_1_S1_L001_R1_001.fastq.gz
Factor1_IP_Tissue1_Control_1,Factor1_IP_Tissue1_Control_1_S2_L001_R1_001.fastq.gz
Factor2_IP_Tissue1_Treated_1,Factor2_IP_Tissue1_Treated_1_S3_L001_R1_001.fastq.gz
Factor2_IP_Tissue1_Control_1,Factor2_IP_Tissue1_Control_1_S4_L001_R1_001.fastq.gz
Input_Tissue1_1,Input_Tissue1_1_S5_L001_R1_001.fastq.gz`;

/**
 * String template for the ATAC CSV file defining the experiment design.
 */
export const AtacSampleTemplate = `SampleName,Replicate,Factor,Tissue,Condition,Treatment
Sample1,1,ATAC,Tissue1,Condition1,Treatment1
Sample2,2,ATAC,Tissue1,Condition1,Treatment1
Sample3,1,ATAC,Tissue2,Condition2,Treatment2`;

/**
 * String template for the ATAC CSV file listing the filenames.
 */
export const AtacSampleFilenamesTemplate = `SampleName,Filename_1_1,Filename_1_2
Sample1,file1_S1_L001_R1_001.fastq.gz,file2_S1_L001_R2_001.fastq.gz
Sample2,file3_S1_L001_R1_001.fastq.gz,file4_S1_L001_R2_001.fastq.gz
Sample3,file5_S1_L001_R1_001.fastq.gz,file6_S1_L001_R2_001.fastq.gz`;
